import ChallengesSection from "./components/ChallengesSection";
import DigitalBusinessPoints from "./components/DigitalBusinessPoints";
import HeroSection from "./components/HeroSection";
import CommonSection from "./components/CommonSection";
import WorkshopBanner from "./components/WorkshopBanne";
import AudienceSection from "./components/AudienceSection";
import TestimonialsSection from "./components/TestimonialsSection";
import BonusSection from "./components/BonusSection";
import MoneyBackGuarantee from "./components/MoneyBackGuarantee";
import FAQSection from "./components/FAQSection";
import BenefitsSection from "./components/BenefitsSection";
import OfferBanner from "./components/OfferBanner";
import Top from "./components/Top";
import DarshanSection from "./components/DarshanSection";



function App() {
  return (
    <div className="App">
      <Top/>
      <HeroSection/>
      <ChallengesSection/>
      <DigitalBusinessPoints/>
      <BenefitsSection/>
      <CommonSection/>
      <WorkshopBanner/>
      <AudienceSection/>
      <TestimonialsSection/>
      <DarshanSection/>
      <BonusSection/>
      <MoneyBackGuarantee/>
      <FAQSection/>
      <OfferBanner/>
      
    </div>
  );
}

export default App;
